export default __webpack_public_path__ + "static/Actions-Schedule-sm@2x-e9a7434d3ea29dce5540104816509abe.jpg";